import BaseService from './baseService';
import {corsProxyOriginalUrl, urlViaCorsProxy} from '~/lib/CORSProxy';

function parseTimeTag(s) {
    const m = /\b(?<month>[A-Z][a-z]+)\s+(?<day>\d{1,2}),?\s+(?<year>\d{4})\b/u.exec(s);
    if (m) {
        return m.groups;
    }
    return null;
}

class Strava extends BaseService {
    urlRe = /^https?:\/\/(?:.+\.)?strava\.com\/activities\/(\d+)/u;

    isOurUrl() {
        return this.urlRe.test(this.origUrl);
    }

    requestOptions() {
        const m = this.urlRe.exec(this.origUrl);
        const trackId = this.trackId = m[1];
        function isResponseSuccess(response) {
            return [200, 401, 404].includes(response.status);
        }
        return [
            {
                url: urlViaCorsProxy(`https://www.strava.com/activities/${trackId}?hl=en-GB`),
                options: {
                    isResponseSuccess
                }
            },
            {
                url: urlViaCorsProxy(`https://www.strava.com/activities/${trackId}/streams?stream_types%5B%5D=latlng`),
                options: {
                    responseType: 'json',
                    isResponseSuccess
                }
            }
        ];
    }

    parseResponse(responses) {
        const [pageResponse, trackResponse] = responses;
        if (trackResponse.status === 404) {
            return [{error: 'Strava activity is deleted or marked as private'}];
        }
        if (trackResponse.status !== 200) {
            return [{error: 'NETWORK', name: this.origUrl}];
        }

        let name = `Strava ${this.trackId}`;
        const latlngs = trackResponse.responseJSON?.latlng;
        if (!latlngs || !Array.isArray(latlngs)) {
            return [{name, error: 'UNSUPPORTED'}];
        }
        const tracks = [latlngs.map((p) => ({lat: p[0], lng: p[1]}))];
        let dom;
        try {
            dom = (new DOMParser()).parseFromString(pageResponse.response, 'text/html');
        } catch (e) {
            // will use default name
        }
        if (dom) {
            const userName = (dom.querySelector('a.minimal[href*="/athletes/"]')?.textContent ?? '').trim();
            const activityTitle = (dom.querySelector('h1.activity-name')?.textContent ?? '').trim();
            const date = parseTimeTag(dom.querySelector('time')?.textContent);
            const formattedDate = date ? ` ${date.day} ${date.month} ${date.year}` : '';
            if (userName && activityTitle) {
                name = `${userName} - ${activityTitle}${formattedDate}`;
            }
        }
        return [{
            name,
            tracks
        }];
    }
}

class StravaShortUrl extends BaseService {
    urlRe = /^https:\/\/strava.app.link\/([A-Za-z0-9]+)/u;

    isOurUrl() {
        return this.urlRe.test(this.origUrl);
    }

    requestOptions() {
        return [
            {
                url: urlViaCorsProxy(this.origUrl),
                options: {isResponseSuccess: (response) => [200, 404].includes(response.status)},
            },
        ];
    }

    parseResponse(responses) {
        const response = responses[0];
        if (response.status === 404) {
            return [{error: 'Strava activity is deleted or marked as private'}];
        }
        const url = corsProxyOriginalUrl(response.responseURL);
        const strava = new Strava(url);
        if (!strava.isOurUrl()) {
            return [{error: 'Bad short link for Strava activity'}];
        }
        return strava.geoData();
    }
}

export {Strava, StravaShortUrl};
